<template>
    <v-container>
        <v-row wrap class="ma-2 justify-center">
          <v-col  cols="12" sm="12" md="6" lg="4" v-for="service in services" :key="service.title"> 
              <v-card elevation="2" class="mb-5 mx-1 rounded-xl"  style=" border-bottom: 5px solid #082543;">
                <v-responsive class="pt-4">
                  <v-avatar  size="70" class=" ml-4 " color="#082543">
                    <v-icon x-large color="#ffffff" v-text="service.icon"/>
                  </v-avatar>
                </v-responsive>
                <v-card-text>
                  <div class="headline font-weight-bold pb-5 " v-text="service.title"/>
                  <div class="grey--text darken-4" v-text="service.text"/>
                </v-card-text>
              </v-card>
          </v-col>
        </v-row>
      </v-container>
</template>

<script>
export default {
    data(){
        return{
            services: [
        { title: 'Mobile Developpement', text:"Native & Hybrid Apps deployed to all stores and supported on all mobiles devices and tablettes.", icon: 'phone_iphone' },
        { title: 'Desktop Developpement', text:"Powerful, fast & rich desktop apps available on demand and tailored to your demands and needs.", icon: 'desktop_mac' },
        { title: 'Web Developpement', text:"Responsive & new. Our web apps adhere to the highest standards & latest technologies.", icon: 'http' },
        { title: 'Game Developpement', text:"Games for all platforms including mobile, web and desktop are available as part of our services", icon: 'sports_esports' },
        { title: 'Augmented reality', text:"Bring your ideas to life with our Augmented Reality apps, available on Android/IOS/Web.", icon: 'qr_code_scanner' },
        { title: 'Graphics design', text:"Beatiful, elegant and modern interfaces and concepts can be ordered for the best prices.", icon: 'mdi-brush' },
      ],
        }
    }
}
</script>